<template>
	<!-- Rien à proposer, rien à montrer : un titre au-dessus d'un tableau vide laissait croire à un
	     chargement qui n'aboutissait pas. -->
	<div v-if="table_busy || bridge_transactions.length">
		<h2>{{ $t('invoice.suggestion_transaction') }}</h2>
		<!-- Associer le mouvement plutôt que saisir le règlement lui donne la date du prélèvement :
		     un règlement daté du jour de saisie n'est ensuite plus proposé au rapprochement du flux. -->
		<p>{{ $t('invoice.suggestion_transaction_hint') }}</p>
		<CustomTable
            id_table="bridge_transactions_suggestions"
            ref="bridge_transactions"
            :items="bridge_transactions"
            :busy.sync="table_busy"
            primaryKey="bridgetransaction_id"
            :hide_if_empty="true"
            :externSlotColumns="extern_slot_columns"
        >
			<template v-slot:[`custom-slot-cell(account_name)`]="{ data }">
				{{ data.bridge_account.bridge_bank.bridgebank_name }} - {{ data.bridge_account.bridgeaccount_name }}<br>
				{{ data.bridge_account.bridgeaccount_iban }}
			</template>
    	</CustomTable>
	</div>
</template>

<script type="text/javascript">
    import OpenBank from "@/mixins/OpenBank.js"
    import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'BankFlowSuggestion',
		props: ['accountingplan_id', 'amount', 'date', 'supplier', 'invoices_ids'],
		mixins: [OpenBank, Navigation],
		data () {
			return {
				extern_slot_columns: ['account_name'],
				bridge_transactions: [],
				table_busy: false,
				events_tab: {
                    'TableAction::goToAssignTransaction': this.goToAssignTransaction,
                },
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				// Le serveur ouvre lui-même la fenêtre autour de la date de facture, et ordonne les
				// mouvements selon leur écart avec elle.
				this.bridge_transactions = await this.getBridgeTransactionSuggestion(this.accountingplan_id, this.amount, this.date) || []
				this.table_busy = false
			},

			async goToAssignTransaction(bridge_transaction) {
				await this.assignBridgeTransaction(bridge_transaction.bridgetransaction_id, this.supplier, this.invoices_ids, undefined, '')
				this.$emit('submit')
			}
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}

</script>